import { matchingEngineApi } from '../matching-engine.utils';
import { UseMutationOptions, useQueryClient } from 'react-query';
import { useMutation } from 'common/hooks';
import { VoteType } from '../matching-engine.utils';

type AddSkillFeedbackParams = {
  revieweeId: string;
  skillId: string;
  feedback?: string;
  voteType: VoteType;
};

export const useAddSkillFeedback = (groupId?: string, options: UseMutationOptions = {}) => {
  const queryClient = useQueryClient();
  const addSkillFeedbackApi = async (feedback: AddSkillFeedbackParams) => {
    return matchingEngineApi.post(
      'add-skill-feedback',
      {
        revieweeId: feedback.revieweeId,
        skillId: feedback.skillId,
        voteType: feedback.voteType,
        feedback: feedback.feedback,
      },
      {
        params: {
          groupId,
        },
      },
    );
  };

  return useMutation(addSkillFeedbackApi, {
    // onSuccess: (data: any, variables: any) => {
    //   queryClient.invalidateQueries({
    //     queryKey: ['pastSkillFeedbacks', variables.revieweeId, variables.skillId],
    //   });

    //   queryClient.invalidateQueries({
    //     predicate: (query) => {
    //       const queryKey = query.queryKey as any[];
    //       return queryKey[1] === 'reportees-profiles';
    //     },
    //   });

    //   options.onSuccess?.(data, variables, undefined);
    // },
    showErrorSnackbar: true,
    ...options,
  });
};
